import { Environments } from "../entities/environment";
import { VERSION } from "../utility/constants";
import {
  NaviError,
  NaviErrorType,
  NaviErrorTypes,
} from "../utility/navi-error";
import windowService from "./window-service";
import { navStateStore } from "../state/nav-state-store";

export const LOGGING_ENDPOINT = "https://logs.nav.porsche.com";

const enum LogLevel {
  DEBUG = "debug",
  INFO = "info",
  ERROR = "error",
}

declare global {
  interface Window {
    PHN_HEADER_VERSION: string;
  }
}

class Logger {
  private version = VERSION;

  private breakpoint = 0;

  private locale: string | null = null;

  init(_: number, locale: string): void {
    this.breakpoint = windowService.getBreakpoint();
    this.locale = locale;
  }

  private log(
    logName: string,
    level: LogLevel,
    id: string,
    message: string,
    errorType?: NaviErrorType,
  ): void {
    const { env } = navStateStore.state;
    if (env === Environments.TEST) {
      return;
    }

    try {
      const log = JSON.stringify({
        name: logName,
        breakpoint: this.breakpoint,
        locale: this.locale,
        version: this.version,
        hostname: windowService.location?.hostname,
        pathname: windowService.location?.pathname,
        id,
        errorType: errorType ?? "",
        level,
        message,
        env,
      });

      if (env === Environments.PRODUCTION) {
        if (level !== LogLevel.DEBUG) {
          fetch(LOGGING_ENDPOINT, {
            method: "POST",
            body: log,
            mode: "no-cors",
          });
        }
      } else {
        // eslint-disable-next-line no-console
        console[level](log);
      }
    } catch (err) {
      //   ignore the error
    }
  }

  info(id: string, message = ""): void {
    this.log("PHN_HEADER_LOG_ENTRY", LogLevel.INFO, id, message);
  }

  error(id: string, err: Error): void {
    const errorType =
      err instanceof NaviError ? err.type : NaviErrorTypes.GENERAL;
    this.log(
      "PHN_HEADER_LOG_ENTRY",
      LogLevel.ERROR,
      id,
      err.message,
      errorType,
    );
  }
}

export default new Logger();
